/*
|--------------------------------------------------------------------------
| Analytics: Comscore
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.analytics.comscore = {

	/**
	 * Track View
	 */
	"track":function(){
		var fetchJSON 	= __gh__webApp.utilities.fetch.json.get,
			baseURL 	= __gh__coreData.siteData.baseURL,
			timeStamp	= new Date().getTime();
		
		//Call comscore api
		(self.COMSCORE && COMSCORE.beacon({c1: "2", c2: "9289482"}));
		
		//Fetch pageview_candidate
		fetchJSON({
			"url": baseURL + "/section?template=JSON_comscore-pageveiw-candidate?&mime=json&" + timeStamp
		});
	}
};